import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=5516c46d&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=5516c46d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516c46d",
  null
  
)

export default component.exports